import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import Toggle from '../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { saloon2ImageOptions } from './views/saloon2'

class XP44Fabric extends Component {
    constructor(props) {
        super(props);
        this.handleFabricChange = this.handleFabricChange.bind(this);
        this.handleHandrailChange = this.handleHandrailChange.bind(this);
        this.handlePleatedBlindsChange = this.handlePleatedBlindsChange.bind(this);
    }


    handleFabricChange(newValue) {
        let configuration = this.props.configuration;
        configuration.FabricSaloon = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleHandrailChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Handrails = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handlePleatedBlindsChange(event) {
        let configuration = this.props.configuration;
        configuration.PleatedBlinds = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
		let imageOptions = saloon2ImageOptions;

        let image = <ConfiguratorImage boat="XP44" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='SALOON' /></h1>
                    <p><Trans defaults='On this image, the cabin is shown with ambient lighting behind the cupboards.' /></p>
                    <h2><Trans defaults='Fabrics' /></h2>
                    <MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.FabricSaloon.label} value={this.props.configuration.FabricSaloon} onChange={this.handleFabricChange} />


                    <h2><Trans defaults='Blinds in coachroof and freeboard' /></h2>
                    <Toggle checked={this.props.configuration.PleatedBlinds.value === 2} onChange={this.handlePleatedBlindsChange}>
                        <Trans defaults='Pleated Blinds' />
                    </Toggle>
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP44Fabric);


// WEBPACK FOOTER //
// ./src/XP44/XP44Fabric.js